import script from "./postcard.vue?vue&type=script&setup=true&lang=js"
export * from "./postcard.vue?vue&type=script&setup=true&lang=js"

import "./postcard.vue?vue&type=style&index=0&id=646047bc&lang=css"

const __exports__ = script;

export default __exports__